import { useEffect, useState } from 'react';

function createImageElement() {
  return document.createElement('img');
}

export function useImageElement(imageData, resetImage, createImage = createImageElement) {
  const [image, setImage] = useState(null);

  const imageId = imageData?.id;
  const imageUrl = imageData?.url;
  const imageSource = imageData?.s3;

  useEffect(() => {
    if (!imageId || !imageUrl) {
      setImage(null);
      return;
    }

    let isCurrent = true;
    const nextImage = createImage();

    nextImage.onload = () => {
      if (isCurrent) setImage(nextImage);
    };

    nextImage.onerror = () => {
      if (isCurrent) resetImage(imageId, imageSource);
    };

    nextImage.src = imageUrl;

    return () => {
      isCurrent = false;
      nextImage.onload = null;
      nextImage.onerror = null;
      nextImage.removeAttribute?.('src');
    };
  }, [createImage, imageId, imageSource, imageUrl, resetImage]);

  return image;
}
